module.exports = __webpack_public_path__ + "img/CameraZOOM-20210712092637796.664837b5.jpg";